module.exports = __webpack_public_path__ + "img/taste-parallax5.ea899191.jpg";